export default "__VITE_ASSET__L0Gl8_Pa__"